import { toTitleCase } from '../utils/utils';

export interface User {
  id?: number;
  empresa_id?: number;
  tipo?: string;
  nome?: string;
  usuario?: string;
  senha?: string;
  confirmacao_senha?: string;
  email?: string;
  situacao?: boolean | 'ativo' | 'inativo';
  ativacao?: boolean | 'ativo' | 'inativo';
  data_criacao?: string | null;
  data_edicao?: string | null;
  sistema?: number;
  ad?: number;
  token?: string;
  token_ativacao?: string;
  perfil_id?: number | null;
  cpf?: string;
  adm_intranet: string;
  senhaAtual?: string;
  tempo_sessao?: number;

  //não existe no backend php, por enquanto rodando sem permissões
  session_permissions?: Permission[];
}

export interface UserForm {
  email: string;
  cpf: string;
  password?: string;
  password_confirmation?: string;
}

export interface Permission {
  id: number;
  module: string;
  permission: string;
  module_label: string;
  permission_label: string;
  submodule: string;
  submodule_label: string;
}

export const getUserName = (user: User) => {
  return toTitleCase(user?.nome || user?.email?.split('@')[0] || '');
};

export const getUserInitials = (user: string | User) => {
  if (typeof user === 'string') {
    return user
      .split(' ')
      .map((name) => name[0])
      .join('');
  }

  return (
    user?.nome
      ?.split(' ')
      .map((name) => name[0])
      .join('') || user?.email?.split('@')[0][0]
  );
};

export const getAvatar = (user: string): string => {
  const names = user.trim().split(/\s+/);

  const firstInitial = names[0][0];
  const lastInitial = names[names.length - 1][0];

  return firstInitial + lastInitial;
};
